import { gql } from "@apollo/client";

export const betDetailsStakeOrders = gql`
  fragment StakeOrder on StakeOrder {
    id
    createdAt
    payout {
      payouts {
        amount
        wallet
      }
    }
    user {
      loungeUsername
      id
      platformIdentifiers {
        id
        gamerTag
        platform
        metadata {
          id
          twitchProfile {
            profileImageUrl
          }
          twitchStreamInfo {
            thumbnailUrl
          }
        }
      }
    }
    fundingSource {
      amount
      wallet
    }
  }
`
